/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ionic-angular/components/modal/modal-component';
import * as import2 from 'ionic-angular/components/backdrop/backdrop';
import * as import3 from 'ionic-angular/navigation/nav-params';
import * as import4 from 'ionic-angular/navigation/view-controller';
import * as import5 from 'ionic-angular/gestures/gesture-controller';
import * as import6 from 'ionic-angular/util/module-loader';
const styles_ModalCmp:any[] = ([] as any[]);
export const RenderType_ModalCmp:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ModalCmp,
  data: {}
}
);
export function View_ModalCmp_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{_viewport: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-backdrop',[
      [
        'disable-activated',
        ''
      ]
      ,
      [
        'role',
        'presentation'
      ]
      ,
      [
        'tappable',
        ''
      ]

    ]
      ,[[
        2,
        'backdrop-no-tappable',
        (null as any)
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import1.ModalCmp = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co._bdClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import2.Backdrop,[
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'modal-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(16777216,[
      [
        1,
        3
      ]
      ,
      [
        'viewport',
        1
      ]

    ]
      ,(null as any),0,'div',[[
        'nav-viewport',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.ModalCmp = v.component;
    const currVal_0:boolean = !co._bdDismiss;
    ck(v,1,0,currVal_0);
  });
}
function View_ModalCmp_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-modal',([] as any[]),(null as any),[[
        'body',
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('body:keyup' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1)._keyUp($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_ModalCmp_0,RenderType_ModalCmp)),
    import0.ɵdid(180224,(null as any),0,import1.ModalCmp,[
      import0.ComponentFactoryResolver,
      import0.Renderer,
      import0.ElementRef,
      import3.NavParams,
      import4.ViewController,
      import5.GestureController,
      import6.ModuleLoader
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ModalCmpNgFactory:import0.ComponentFactory<import1.ModalCmp> = import0.ɵccf('ion-modal',import1.ModalCmp,View_ModalCmp_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvbW9kYWwvbW9kYWwtY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL25vZGVfbW9kdWxlcy9pb25pYy1hbmd1bGFyL2NvbXBvbmVudHMvbW9kYWwvbW9kYWwtY29tcG9uZW50LmQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9ub2RlX21vZHVsZXMvaW9uaWMtYW5ndWxhci9jb21wb25lbnRzL21vZGFsL21vZGFsLWNvbXBvbmVudC5kLnRzLk1vZGFsQ21wLmh0bWwiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9ub2RlX21vZHVsZXMvaW9uaWMtYW5ndWxhci9jb21wb25lbnRzL21vZGFsL21vZGFsLWNvbXBvbmVudC5kLnRzLk1vZGFsQ21wX0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGlvbi1iYWNrZHJvcCAoY2xpY2spPVwiX2JkQ2xpY2soKVwiIFtjbGFzcy5iYWNrZHJvcC1uby10YXBwYWJsZV09XCIhX2JkRGlzbWlzc1wiPjwvaW9uLWJhY2tkcm9wPjxkaXYgY2xhc3M9XCJtb2RhbC13cmFwcGVyXCI+PGRpdiAjdmlld3BvcnQgbmF2LXZpZXdwb3J0PjwvZGl2PjwvZGl2PiIsIjxpb24tbW9kYWw+PC9pb24tbW9kYWw+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFBYztRQUFBO1FBQUE7TUFBQTtNQUFkO0lBQUE7Z0JBQUE7OztJQUFBO0tBQUE7TUFBNkY7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUFyRjtJQUFuQyxTQUFtQyxTQUFuQzs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7Ozs7O0lBQUE7S0FBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/modal/modal-component.ngfactory.ts